"use client";

import { cn } from "@kyan/ui";
import React from "react";
import { Address } from "viem";

import { useFetchAccountState } from "#/services/kyan/hooks/useFetchAccountState";
import { useMarket } from "#/store/app/portfolio/market";
import { useAccount } from "#/store/wallet/account/account";
import { PortfolioSymbol, type UnderlyingSymbol } from "#/types/markets";

import { PortfolioRiskItem } from "./components/PortfolioRiskItem/PortfolioRiskItem";

interface PortfolioRiskItemsProps {
  account?: Address;
}

export const PortfolioRiskItems: React.FC<PortfolioRiskItemsProps> = ({
  account,
}) => {
  const { setMarketByUnderlying } = useMarket();
  const { setAccount } = useAccount();
  const { accountState } = useFetchAccountState({
    account,
  });

  const handleSelect = (market: UnderlyingSymbol) => {
    setMarketByUnderlying(market);
    setAccount(account);
  };

  return (
    <>
      {Object.entries(accountState).map(([underlying, state]) => {
        const isUSDCUnderlying =
          (underlying as PortfolioSymbol) === PortfolioSymbol.USDC;

        const onSelect = () => {
          if (!isUSDCUnderlying) {
            handleSelect(underlying as UnderlyingSymbol);
          }
        };

        return (
          <button
            key={state.pair + account}
            className={cn(
              "border-divider dark:bg-buttonBg flex h-auto w-full cursor-pointer items-center justify-between border-b bg-white py-4 pr-10 pl-4 text-xs transition-colors select-none last:border-b-0 focus:outline-none",
              {
                "cursor-default pr-4": isUSDCUnderlying,
                "hover:bg-buttonHover": !isUSDCUnderlying,
              },
            )}
            onClick={onSelect}
            onKeyDown={onSelect}
          >
            <PortfolioRiskItem
              accountState={state}
              isUSDCUnderlying={isUSDCUnderlying}
              underlying={underlying as PortfolioSymbol}
            />
          </button>
        );
      })}
    </>
  );
};
